module.exports = __webpack_public_path__ + "static/mat1640_compilado-8b86a5e4bf4e695c6a5835b88455845f.pdf";